import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Force the scroll to the top left of the window
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "instant" // Use "instant" to prevent flashing old content at bottom
        });
    }, [pathname]);

    return null;
};

export default ScrollToTop;
